/**
 * Service for sending feedback to Convo AI
 * Endpoint: /gateway/api/assist/rovo/v1/chat/conversation/{conversationId}/message/{messageId}/feedback
 */

export interface ConvoAIFeedbackParams {
	conversationId: string;
	messageId: string;
	feedbackValue: 'LIKE' | 'DISLIKE';
	feedbackText?: string;
	feedbackCategories?: string[];
	productHeader: string;
	experienceId: string;
	channelId: string;
	cloudId: string;
}

export interface ConvoAIFeedbackResponse {
	success: boolean;
}

/**
 * Sends feedback to Convo AI endpoint
 */
export const sendConvoAIFeedback = async ({
	conversationId,
	messageId,
	feedbackValue,
	feedbackText,
	feedbackCategories,
	productHeader,
	experienceId,
	channelId,
	cloudId,
}: ConvoAIFeedbackParams): Promise<ConvoAIFeedbackResponse> => {
	try {
		const url = `/gateway/api/assist/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/feedback`;

		const body: Record<string, unknown> = {
			feedback_value: feedbackValue,
		};

		if (feedbackText) {
			body.feedback_text = feedbackText;
		}

		if (feedbackCategories && feedbackCategories.length > 0) {
			body.feedback_categories = feedbackCategories;
		}

		const response = await fetch(url, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
				'X-Product': productHeader,
				'X-Experience-Id': experienceId,
				'X-Channel-Id': channelId,
				'X-Cloudid': cloudId,
			},
			credentials: 'include',
			body: JSON.stringify(body),
		});

		if (!response.ok) {
			return Promise.reject(
				new Error(`Convo AI feedback request failed: ${response.status} ${response.statusText}`),
			);
		}

		return { success: true };
	} catch (error) {
		return Promise.reject(error);
	}
};
